<div *ngIf="(msgData && msgData.content && msgData.content.length>0) || redesign || showOutage" class="container" [attr.data-qa]="'bu-msg-container'">
    <ng-container *ngIf="showOutage">
        <div *ngFor="let outage of outages">
            <div class="alert alert-warning system-msg {{outage.outageId}}-system-msg"
                role="alert" *ngIf="outage.messageContent && !outage.closed" [attr.data-qa]="'outage-msg-alert'">
                
                <span class="sr-only" [attr.data-qa]="'bu-msg-msgType'">Warning</span>
                <h2 class="h3 alert-title" [attr.data-qa]="'bu-msg-msgTitle'" *ngIf="outage.messageContent?.subTitle">{{outage.messageContent?.subTitle}}</h2>
                <div class="msg-body" [attr.data-qa]="'bu-msg-msgBody'" [innerHTML]="outage.messageContent?.message | safeHtml"></div>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="msgData && msgData.content && msgData.content.length>0">
        <div *ngFor="let cntnt of msgData.content | orderBy:['seq']">
            <div class="alert alert-{{cntnt.msgType.toLowerCase()}} alert-dismissable system-msg {{cntnt.buName}}-system-msg"
                role="alert" *ngIf="!cntnt.closed" [attr.data-qa]="'bu-msg-alert'">
                <button type=" button" class="close catelog-close" data-dismiss="alert"
                    (click)="closeBuMsg(cntnt.buName)" [attr.data-qa]="'bu-msg-close'">
                    <span aria-hidden="true" class="fa fa-times"></span>
                    <span class="sr-only">Close alert message</span>
                </button>
                <span class="sr-only" [attr.data-qa]="'bu-msg-msgType'">{{cntnt.msgType}}</span>
                <h2 class="h3 alert-title" [attr.data-qa]="'bu-msg-msgTitle'">{{cntnt.msgTitle}}</h2>
                <div class="msg-body mt-2" [attr.data-qa]="'bu-msg-msgBody'" [innerHTML]="cntnt.msgBody | safeHtml"></div>
            </div>
        </div>
    </ng-container>
    <!-- <div class="alert alert-info alert-dismissable abtest-msg" role="alert" *ngIf="redesign && !ABClosed">
        <button type=" button" class="close catelog-close" data-dismiss="alert" (click)="closeBuMsg('abTest')">
            <span aria-hidden="true" class="fa fa-times"></span>
            <span class="sr-only">Close alert message</span>
        </button>
        <span class="sr-only">info</span>
        <p class="h3 alert-title">A/B TEST MSG</p>
        <div class="msg-body mt-2">Lucky user selected for AB testing!</div>
    </div> -->
</div>